import { animate, state, style, transition, trigger } from "@angular/animations";
import { AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import timepicker_enUS from "src/app/lib/guru-timepicker/i18n/en-US.json";
import timepicker_esES from "src/app/lib/guru-timepicker/i18n/es-ES.json";
import timepicker_ptBR from "src/app/lib/guru-timepicker/i18n/pt-BR.json";
import shared_enUS from "src/app/shared/i18n/en-US.json";
import shared_esES from "src/app/shared/i18n/es-ES.json";
import shared_ptBR from "src/app/shared/i18n/pt-BR.json";
import { ThemingService } from "./core/service/theme/theming.service";
import { UpdateApplicationService } from "./core/service/update-application.service";
import enUS from "./i18n/en-US.json";
import esES from "./i18n/es-ES.json";
import ptBR from "./i18n/pt-BR.json";
import { AchievementPlayerDialogService } from "./shared/component/achievement-player-dialog/achievement-player-dialog.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    animations: [
        trigger("esvanecerDesvanecer", [
            state("*", style({ display: "flex" })),
            state("out", style({ display: "none" })),

            transition("* => out", animate(100))
        ])
    ]
})
export class AppComponent implements OnInit, AfterViewInit {
    title = "GuruMatch";
    public logoSecondary$: Observable<string>;
    favIcon: HTMLLinkElement = document.querySelector("#appIcon");

    @ViewChild("achievementDialog", { read: ViewContainerRef })
    entry!: ViewContainerRef;

    constructor(
        private translate: TranslateService,
        private themeService: ThemingService,
        private updateApplicationService: UpdateApplicationService,
        public achievementMsgService: AchievementPlayerDialogService,
        private router: Router
    ) {
        this.logoSecondary$ = this.themeService.currentThemeAsync.pipe(
            map((theme) => {
                return theme.images.secondaryLogoUrl;
            })
        );

        this.updateApplicationService.CheckNewVersionAndUpdate();
    }

    ngAfterViewInit(): void {
        this.achievementMsgService.setEntry(this.entry);
    }

    ngOnInit(): void {
        this.translate.setTranslation("pt-BR", timepicker_ptBR, true);
        this.translate.setTranslation("en-US", timepicker_enUS, true);
        this.translate.setTranslation("es-ES", timepicker_esES, true);

        this.translate.setTranslation("pt-BR", shared_ptBR, true);
        this.translate.setTranslation("en-US", shared_enUS, true);
        this.translate.setTranslation("es-ES", shared_esES, true);
        this.translate.setTranslation("pt-BR", ptBR, true);
        this.translate.setTranslation("en-US", enUS, true);
        this.translate.setTranslation("es-ES", esES, true);

        if (localStorage.getItem("locale") != null) this.translate.use(localStorage.getItem("locale"));
        else this.translate.use("pt-BR");
    }
}
